'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('react');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var search = require('./search-c27fa133.js');

var TouchSearchBarContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  background-color: ", ";\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: row;\n  border: 1px solid ", ";\n  color: ", ";\n  .disabled-true {\n    color: ", ";\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  background-color: ", ";\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: row;\n  border: 1px solid ", ";\n  color: ", ";\n  .disabled-true {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedDarkGrey;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMediumAlt;
});
var TouchSearchBarWrapper = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  width: 339px;\n  height: 36px;\n"], ["\n  width: 339px;\n  height: 36px;\n"])));
var RightTextWrapper = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var GhostTouchSearchBar = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  width: 339px;\n  height: 36px;\n  border-radius: 5px;\n  box-sizing: border-box;\n  background-color: ", ";\n"], ["\n  width: 339px;\n  height: 36px;\n  border-radius: 5px;\n  box-sizing: border-box;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var StyledSearch = styled__default(search.Search)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  margin-left: 14px;\n"], ["\n  margin-left: 14px;\n"])));
var TouchBlock = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 22px;\n  margin-left: ", ";\n  color: ", ";\n  &:hover:not([disabled]), &:focus:not([disabled]) {\n    color: ", ";\n    background-color: ", ";\n  }\n  pointer-events: ", ";\n"], ["\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 22px;\n  margin-left: ", ";\n  color: ", ";\n  &:hover:not([disabled]), &:focus:not([disabled]) {\n    color: ", ";\n    background-color: ", ";\n  }\n  pointer-events: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var isLeftLabel = _a.isLeftLabel;
    return (isLeftLabel ? '13px' : 0);
}, function (_a) {
    var theme = _a.theme, label = _a.label;
    return (label && theme.colors.greys.darkGrey7);
}, function (_a) {
    var theme = _a.theme, label = _a.label;
    return (label ? theme.colors.greys.topNav : theme.colors.greys.darkGrey3);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.transparent;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'none' : 'initial');
});
var TouchBlockWrapper = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  cursor: ", ";\n"], ["\n  cursor: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var StyledDot = styled__default.div(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  width: 5px;\n  margin: 0 8px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: ", ";\n"], ["\n  width: 5px;\n  margin: 0 8px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme, leftLabel = _a.leftLabel, rightLabel = _a.rightLabel, disabled = _a.disabled;
    return ((leftLabel || rightLabel) && !disabled
        ? theme.colors.greys.darkGrey7
        : theme.colors.greys.sharedDarkGrey);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

exports.GhostTouchSearchBar = GhostTouchSearchBar;
exports.RightTextWrapper = RightTextWrapper;
exports.StyledDot = StyledDot;
exports.StyledSearch = StyledSearch;
exports.TouchBlock = TouchBlock;
exports.TouchBlockWrapper = TouchBlockWrapper;
exports.TouchSearchBarContainer = TouchSearchBarContainer;
exports.TouchSearchBarWrapper = TouchSearchBarWrapper;
